module.exports = __webpack_public_path__ + "static/bluets-402fdbb245222852c90bd3ec9d239844.jpg";